import { styled } from '@mui/system';
import StyledSelectColorAndBorderSectionNavLinkMain from 'components/StyledSelectColorAndBorderSectionNavLinkMain';

const StyledSelectOptionColors = styled(
  StyledSelectColorAndBorderSectionNavLinkMain
)(({ theme }) => ({
  '& .MuiNativeSelect-select.MuiNativeSelect-outlined option': {
    backgroundColor: theme.palette.soy,
    color: theme.palette.white
  }
}));

export default StyledSelectOptionColors;
